<template>
  <div class="menu-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <div v-if="item.uuid==''" >
                <i className="fa fa-align-justify"></i><strong>{{ $t('common.create') }}</strong>
              </div>
              <div v-if="item.uuid!=''" >
                <i className="fa fa-align-justify"></i><strong>{{ $t('common.edit') }}</strong>
              </div>
            </div>
            <b-form class="row" v-if="item != null">
              <b-col cols="6">
                <b-form-group v-bind:label="$t('role.name')" :label-cols="3" :horizontal="true">
                  <b-form-input
                    class="form-control"
                    v-model="item.name"
                    :state="!$v.item.name.$invalid"
                    :aria-describedby="'name-feedback'" />
                  <b-form-invalid-feedback :id="'name-feedback'">
                    {{ $t('message.required_filed') }}
                  </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group v-bind:label="$t('role.permission')" :label-cols="3" :horizontal="true">
                  <multiselect select-label="" :hide-selected="true" v-model="item.permissions"
                               :placeholder="$t('role.search_permission')"
                               label="name" track-by="code" :options="permission_options" :multiple="true" :taggable="true"
                  >
                  </multiselect>
                </b-form-group>

              </b-col>

            </b-form>
            <div slot="footer">
              <div class="text-center">
                <b-button variant="default" v-on:click="$router.go(-1)" ><i class="fa fa-arrow-left"></i>&nbsp; {{$t('common.back')}}</b-button>
                <b-button variant="success" v-on:click="saveRole()" :disabled="checkSubmit()" ><i class="fa fa-arrow-right"></i>&nbsp; {{$t('common.save')}}</b-button>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {required, minLength, maxLength, between, integer, minValue, email, decimal, or, numeric } from 'vuelidate/lib/validators'
  import cSwitch from '../../../components/Switch'
  import Tables from '../../tables/Tables'
  import Multiselect from 'vue-multiselect'
  let vm = null

  export default {
    name: 'RoleForm',
    props: {
      uuid: {
        type: String
      }
    },
    components: {
      Tables,
      cSwitch,
      Multiselect
    },
    data: function () {
      return {
        permission_options: [],
        item: {
          uuid: '',
          name: "",
          slug: "",
          permissions: []
        }
      }
    },
    mixins: [
      validationMixin
    ],
    validations: {
      item: {
        name: {
          required
        }
      }
    },
    methods: {
      checkSubmit: function(){
        return vm.$v.item.$invalid
      },
      isJSON: function(str) {
        try {
          JSON.parse(str)
        } catch (e) {
          return false
        }
        return true
      },
      /**
       * upload image then move to next form
       */
      saveRole() {
        for (var i = 0; i <= vm.item.permissions.length; i++) {
          if (typeof  vm.item.permissions[i] !== 'undefined') {
            vm.item.permissions[i] = vm.item.permissions[i].code
          }
        }
        if (vm.uuid == 'create' || vm.uuid == undefined) {
          vm.item.slug = vm.item.name.trim().replace(/ /g, '_').toLowerCase()
          vm.axios.user.createRole(vm.item, function(response){
            vm.$router.push({name: 'role_list'})
          })
        }
        else{ // update client
          vm.axios.tenant.updateRole(vm.uuid, vm.item, function(response){
            vm.$router.push({name: 'role_list'})
          }, error => {
            console.log('error', error)
          })
        }
      },
    },
    created: function () {
      vm = this
    },
    mounted: function () {
      // get list roles
      vm.axios.user.getPermissionList('?ignore_limit=1', respone => {
        if (respone.status === 200) {
          let permissionDataList = respone.data.data.items
          for (var i = 0; i <= permissionDataList.length; i++) {
            if (typeof permissionDataList[i] !== 'undefined') {
              vm.permission_options.push({name: permissionDataList[i].name, code: permissionDataList[i].slug})
            }
          }
        }
      }, error => {
        console.log('error', error)
      })
      if (vm.uuid == 'create' || vm.uuid == undefined) {
      }
      else{
        vm.axios.tenant.getRoleDetail(vm.uuid, function(response){
          if (response.status === 200) {
            let item = JSON.parse(JSON.stringify(response.data.data.item))
            let permissions = []
            for (var i = 0; i <= item.permission.length; i++) {
              if (typeof item.permission[i] !== 'undefined') {
                vm.item.permissions.push({name: item.permission[i].name, code: item.permission[i].slug})
                vm.permission_options.push({name: item.permission[i].name, code: item.permission[i].slug})
              }
            }
            vm.item.name = item.name
            vm.item.slug = item.slug
            // vm.item = item
            // vm.item.permissions = permissions
          }
        })
      }
    }
  }
</script>

<style scoped>
  .input-group-text .custom-checkbox {
    margin-right: 0px;
    padding-left: 1.0rem;
  }

  .input-group-text {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 0.375rem 0.75rem;
    margin-bottom: 0;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #3e515b;
    text-align: center;
    white-space: nowrap;
    background-color: #f8f9fa;
    border: 1px solid #e4e5e6;
  }

  .custom-checkbox {
    padding-left: 0px;
  }

  .col-6{
    float: left;
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/admin/roles/BaseForm.vue